import { Component, Injectable, OnInit } from '@angular/core';
import { MessageService } from 'primeng/api';
import { EleitorDTO } from 'src/app/models/eleitorDTO.model';
import { NewEleitorDTO } from 'src/app/models/newEleitorDTO.model';
import { EleicaoService } from 'src/app/services/eleicao.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { FormControl, FormGroup } from '@angular/forms';
import { Utils } from 'src/app/utils/utils';
import { Page } from 'src/app/models/page.model';


@Component({
  selector: 'app-envio',
  templateUrl: './envio.component.html',
  styleUrls: ['./envio.component.css']
})
@Injectable()
export class EnvioComponent implements OnInit {
  currentLocation: string;
  formCadastroEleitores: FormGroup;
  idEleicao: any;
  idGestor: number;
  token: any;
  listaEnvioEleitores: EleitorDTO[]
  pageEnvioEleitores: Page = new Page()
  eleitores: EleitorDTO[];
  editandoEleitor: boolean = false;
  idEleitorEditando: any;
  newEleitorDTO: NewEleitorDTO = new NewEleitorDTO();
  duplicados: any = [];
  retornoDuplicados: boolean = false;
  eleicao: any;
  validaEmail: boolean = true;
  public checaValidacao: boolean = true;
  btOff: boolean = true;
  model: NewEleitorDTO = { login: '', email: '', senha: '', plano: '', estado: null, eleicao: null, idGestor: null };
  public page:Page;
  randomSenha: string;
  carregandoEleitores: boolean;
  paginaAtual : Number = 1 ;
  contador : Number = 30;

  constructor(
    private eleicaoService: EleicaoService,
    protected messageService: MessageService,
    public spinner: NgxSpinnerService,
    public utils: Utils
  ) { }

  ngOnInit() {
    this.spinner.show();
    this.idEleicao = JSON.parse(sessionStorage.getItem("eleicaoClicadaParametrizacao")).id;
    this.eleicao = JSON.parse(sessionStorage.getItem("eleicaoClicadaParametrizacao"));
    this.idGestor = JSON.parse(sessionStorage.getItem("infoGestor")).id;
    this.token = sessionStorage.getItem("token");
    this.listaEnvioEleitores = [];
    this.eleitores = [];
    this.spinner.hide();
  }

  envioEleitores() {
    if (this.listaEnvioEleitores.length == 0) {
        this.messageService.add({ key: 'toast', severity: 'error', summary: 'Ops!', detail: 'Por favor carregue uma lista de e-mails para realizar o envio.' });
    } else {
      this.btOff = true;
      // Realiza o Envio
      this.enviarEmails(this.listaEnvioEleitores, this.token);
    }
  }

  validaFormulario() {
    if (this.eleicao.statusEleicao != 'EM_ANDAMENTO') {
      this.checaValidacao = true;
    } else {
      this.checaValidacao = false;
    }
  }

  baixarTemplate() {
    let csvHeader = 'login;email'
    this.utils.baixarModeloCsv(csvHeader, "lista_envio_logins_eleitores")
  }

  public buscarEleitoresPorEleicaoId() {
    this.eleicaoService.findAllEleitoresByEleicaoId(this.idEleicao, this.token).then((res: EleitorDTO[]) => {
      if (res != null && res.length > 0) {
        this.listaEnvioEleitores = res;
        this.eleitores = this.listaEnvioEleitores;
        this.btOff = false;
      } else {
        this.messageService.add({ key: 'toast', severity: 'error', summary: 'Informação', detail: 'Ainda não existem eleitores cadastros para essa eleição' });
      }
    })
  }

  public eleitoresPorImportacaoLista(eleitores: NewEleitorDTO[]) {
    if (eleitores != null && eleitores.length > 0) {
      this.listaEnvioEleitores = eleitores;
      this.eleitores = this.listaEnvioEleitores;
      this.btOff = false;
    } else {
      this.messageService.add({ key: 'toast', severity: 'error', summary: 'Informação', detail: 'Ainda não existem eleitores cadastros para essa eleição' });
    }
  }

  public filtrarEleitoresPorNome(){
    var eleitorBuscado = (<HTMLInputElement>document.getElementById("filtroEleitor")).value;
    this.eleitores = this.listaEnvioEleitores.filter((value) => {
      if(value.login.toLowerCase().includes(eleitorBuscado.toLowerCase())){
        return value
      }
    this.btOff = false;        
    })
  }

  limparFiltro(){
    (<HTMLInputElement>document.getElementById("filtroEleitor")).value = '';
    this.eleitores = this.listaEnvioEleitores
    this.btOff = true;
  }

  public enviarEmails(e: EleitorDTO[], token: any) {
    this.messageService.add({ key: 'toast', severity: 'success', summary: 'Sucesso!', detail: 'O envio de e-mails está sendo iniciado pela aplicação!' });
    this.eleicaoService.enviarEmailsLoginEleitor(this.idEleicao, e, token).then((res: EleitorDTO[]) => {
      document.body.style.cursor = 'default';
      this.btOff = true;
      this.listaEnvioEleitores = []
      this.eleitores = []
      this.messageService.add({ key: 'toast', severity: 'success', summary: 'Sucesso!', detail: 'E-mails enviados com sucesso!' });
    }, error => {
      document.body.style.cursor = 'default';
      this.btOff = false;
      this.messageService.add({ key: 'toast', severity: 'error', summary: 'Atenção!', detail: error });
      this.formCadastroEleitores.reset();
      this.randomSenha = '';
    });
  }

}
